import PaymentWidget from "widget/PaymentWidget"
import { premiumAmount } from "shared/constant/amountList"

const PremiumPayment = () => {
    const props = {
        "amount": premiumAmount,
        "orderName": `프리미엄 계정 라이센스 (1개월)`,
        "callbackUrl": `premium/done`
    }

    return (
        <PaymentWidget {...props} />
    )
}

export default PremiumPayment